// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#emails{padding-bottom:20px}.click{cursor:pointer}table{width:100%}tr{height:20px}#emails-top{display:flex;justify-content:space-between;align-items:center}#emails-top span{margin-left:30px}#emails-top a{margin-right:30px;width:30%}#emails-top button{cursor:pointer;width:100%;border-radius:10px;border:none;height:30px;background-color:#20b2aa;color:#fff}#emails-top button:hover{background-color:#fff;color:#20b2aa;border:1px solid #20b2aa}", ""]);
// Exports
module.exports = exports;
